// src/components/categories/CategoryGrid.jsx
import React from 'react';
import { 
  Grid, 
  Box, 
  Typography,
  Zoom
} from '@mui/material';
import { motion } from 'framer-motion';
import CategoryCard from './CategoryCard';
import { useCategories } from '../../context/CategoryContext';
import { useTranslation } from 'react-i18next';

const CategoryGrid = ({ categories: propCategories }) => {
  const { categories: contextCategories, loading, error } = useCategories();
  const { t } = useTranslation('common');
  
  // Utiliser les catégories passées en props ou celles du contexte
  const categories = propCategories || contextCategories;

  if (loading) return null;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!categories || categories.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.secondary">
          {t('categories.noCategories')}
        </Typography>
      </Box>
    );
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12
      }
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <Grid container spacing={3}>
        {categories.map((category, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={category.id}>
            <Zoom in timeout={300 + index * 100}>
              <motion.div variants={itemVariants}>
                <CategoryCard 
                  category={category}
                  elevation={2}
                  sx={{
                    height: '100%',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 4
                    }
                  }}
                />
              </motion.div>
            </Zoom>
          </Grid>
        ))}
      </Grid>
    </motion.div>
  );
};

export default CategoryGrid;
